/**
 * @generated SignedSource<<8f4988e5331d62d6ba7ff2770db919ae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type homeSuperSplashInlineQuery$data = {
  readonly liveWidget: {
    readonly relatedArticles: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"helpersIsArticleVideoAsHeroArticle">;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "homeSuperSplashInlineQuery";
};
export type homeSuperSplashInlineQuery$key = {
  readonly " $data"?: homeSuperSplashInlineQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"homeSuperSplashInlineQuery">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "homeSuperSplashInlineQuery"
};

(node as any).hash = "623da15e3499e006bbc7bd01c892cf0f";

export default node;
